import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { SEOHead } from '../components/SEO/SEOHead';
import PublicHeader from '../components/landing/PublicHeader';
import PublicFooter from '../components/landing/PublicFooter';
import PageHero from '../components/landing/PageHero';
import CtaSection from '../components/landing/CtaSection';
import { articles } from '../content/articles';
import { blogIndexJsonLd, formatDate } from '../content/render';
import '../components/landing/landing.css';
import './Blog.css';

export const BLOG_TITLE = 'Telegram Stars Blog: Guides on Payments, Fees, Withdrawals & Bot API';
export const BLOG_DESCRIPTION =
  'Practical guides on Telegram Stars: how to accept payments, create payment links, understand fees, withdraw Stars to TON, use the Bot API and monetize a Telegram audience.';

const Blog: React.FC = () => {
  const [featured, ...rest] = articles;
  return (
    <>
      <SEOHead
        title={BLOG_TITLE}
        description={BLOG_DESCRIPTION}
        canonical="/blog/"
        keywords="telegram stars blog, telegram stars guide, telegram payments guide, telegram monetization"
      />
      <Helmet>
        <link rel="alternate" type="application/rss+xml" title="Telegram Stars Blog" href="https://www.telegram-stars.io/rss.xml" />
        <script type="application/ld+json">{JSON.stringify(blogIndexJsonLd(articles))}</script>
      </Helmet>

      <PublicHeader />

      <div className="ts-landing blog-page">
        <PageHero
          eyebrow="Blog"
          title="Telegram Stars Blog"
          subtitle="Guides, tutorials and comparisons to help creators, merchants and developers get paid with Telegram Stars."
        />

        <section className="blog-list">
          <div className="ts-container">
            {featured && (
              <Link to={`/blog/${featured.slug}`} className="blog-card blog-card--featured">
                <div className="blog-card-meta">
                  <span className="blog-card-category">{featured.category}</span>
                  <time dateTime={featured.datePublished}>{formatDate(featured.datePublished)}</time>
                  <span>{featured.readingTimeMin} min read</span>
                </div>
                <h2 className="blog-card-title">{featured.title}</h2>
                <p className="blog-card-excerpt">{featured.excerpt}</p>
                <span className="blog-card-cta">Read the guide →</span>
              </Link>
            )}
            <div className="blog-grid">
              {rest.map((a) => (
                <Link key={a.slug} to={`/blog/${a.slug}`} className="blog-card">
                  <div className="blog-card-meta">
                    <span className="blog-card-category">{a.category}</span>
                    <time dateTime={a.datePublished}>{formatDate(a.datePublished)}</time>
                  </div>
                  <h2 className="blog-card-title">{a.title}</h2>
                  <p className="blog-card-excerpt">{a.metaDescription}</p>
                  <span className="blog-card-cta">Read more →</span>
                </Link>
              ))}
            </div>
          </div>
        </section>

        <CtaSection />
        <PublicFooter />
      </div>
    </>
  );
};

export default Blog;
